module.exports = __webpack_public_path__ + "packs/media/images/lexiqamus/ekual-announcement-megaphone-f8ea0410917404cca2d3c154132361ae.svg";